import React, {useContext} from 'react';
import {Form, Col, Row, Container, Button, Dropdown} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faFilter} from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import './historique.css';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {MadricContext} from '../../../Context/MadricContext';


/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function HistoriqueFilter(props) {
  const {listeEmploye} = useContext(MadricContext);

  const handleOptionChange = (option) => {
    if (props.selectedOptions.current.includes(option)) {
      props.selectedOptions.current = props.selectedOptions.current.filter((selected) => selected !== option);
    } else {
      props.selectedOptions.current = [...props.selectedOptions.current, option];
    }
    props.setReload((previous) => !previous);
  };

  return (
    <Container fluid style={{width: '90%'}}>
      <div style={{width: '100%', borderTop: '2px solid black', marginBottom: '10px'}}></div>

      <Form>
        <Row className="mb-3">
          <div className="chantierheure-filter-container">

            <Dropdown >
              <Dropdown.Toggle
                className="chantierheure-form-control"
                style={{
                  backgroundColor: 'white',
                  marginTop: '0px',
                  marginLeft: '0px',
                  color: 'black',
                  height: '47px',
                  border: '2px solid black',
                }}>
                {props.filterFormGlobal.current.name.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {listeEmploye.map((user, index) => {
                  return <Dropdown.Item key={index} onClick={() => props.handleChangeGlobal(user)}>{user.label}</Dropdown.Item>;
                })}
              </Dropdown.Menu>
            </Dropdown>

            <DatePicker
              className="chantierheure-form-control-histo"
              type="date"
              onChange={props.handleDateChangeDebut}
              name="dateDebut"
              placeholderText="Date ancien"
              selected={props.filterFormGlobal.current.dateDebut}
              dateFormat="dd-MM-yyyy" />
            <DatePicker
              className="chantierheure-form-control-histo"
              type="date"
              name="dateFin"
              onChange={props.handleDateChangeFin}
              selected={props.filterFormGlobal.current.dateFin}
              placeholderText="Date récent"
              dateFormat="dd-MM-yyyy" />
            <FontAwesomeIcon
              className="chantierheure-trash-icon"
              onClick={() => props.removeFilter()}
              icon={faTrash} />
          </div>
          <div className="chantierheure-filter-container">
            <DatePicker
              className="chantierheure-form-control2"
              type="text"
              onChange={props.handleDateChangeDebut}
              name="dateDebut"
              placeholderText="Date ancien"
              selected={props.filterFormGlobal.current.dateDebut}
              dateFormat="dd-MM-yyyy" />
            <DatePicker
              className="chantierheure-form-control2"
              type="text"
              onChange={props.handleDateChangeFin}
              name="dateFin"
              selected={props.filterFormGlobal.current.dateFin}
              placeholderText="Date récent"
              dateFormat="dd-MM-yyyy" />
            <FontAwesomeIcon
              className="chantierheure-trash-icon2"
              onClick={() => props.removeFilter()}
              icon={faTrash}
            />
          </div>
        </Row>
      </Form>
      <div style={{display: 'flex', justifyContent: 'center', marginBottom: '10px'}}>

        <MDBCheckbox name='extra1' label='Extra possible' defaultChecked={props.filterFormGlobal.current.extra1} inline onChange={props.handleCheckboxChangeGlobal} />
        {localStorage.getItem('admin') === '1' &&
             <React.Fragment>
               <MDBCheckbox name='extra2' label='Extra valider' defaultChecked={props.filterFormGlobal.current.extra2} inline onChange={props.handleCheckboxChangeGlobal} />
               <MDBCheckbox name='extra3' label='Extra confirmer' defaultChecked={props.filterFormGlobal.current.extra3} inline onChange={props.handleCheckboxChangeGlobal} />
             </React.Fragment>}
      </div>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <div style={{borderBottom: '2px solid black', width: '50%', marginBottom: '30px'}}>

        </div>
      </div>


      <Form>
        <Row className="mb-3">
          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="todolist"
              label="To-Do List"
              defaultChecked={props.selectedOptions.current.includes('todolist')}
              onChange={() => handleOptionChange('todolist')}
              style={{maxWidth: '20px'}}
            />
            {props.selectedOptions.current.includes('todolist') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Complete</label>
                  <input
                    type="checkbox"
                    name="toComplete"
                    defaultChecked={props.filterForm.current.toComplete}
                    onChange={props.handleCheckboxChange} />
                  <div></div>
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Non complete</label>
                  <input
                    type="checkbox"
                    name="toNonComplete"
                    defaultChecked={props.filterForm.current.toNonComplete}
                    onChange={props.handleCheckboxChange}/>
                </Col>
              </Form.Group>

            )}
          </Col>
          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="check-in"
              label="Check-in"
              defaultChecked={props.selectedOptions.current.includes('checkin')}
              onChange={() => handleOptionChange('checkin')}
            />
            {props.selectedOptions.current.includes('checkin') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <input
                    style={{height: '32px'}}
                    type="text"
                    className="chantierheure-input"
                    placeholder="Note"
                    name="chNote"
                    defaultValue={props.filterForm.current.chNote}
                    onChange={props.handleChange} />
                  <div></div>
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Transport</label>
                  <input
                    type="checkbox"
                    name="chTransport"
                    defaultChecked={props.filterForm.current.chTransport}
                    onChange={props.handleCheckboxChange} />

                </Col>
              </Form.Group>

            )}
          </Col>
          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="photo"
              label="Photos"
              defaultChecked={props.selectedOptions.current.includes('photo')}
              onChange={() => handleOptionChange('photo')}
            />
            {props.selectedOptions.current.includes('photo') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <input
                    style={{height: '32px'}}
                    type="text"
                    className="chantierheure-input"
                    placeholder="Note"
                    name="phNote"
                    defaultValue={props.filterForm.current.phNote}
                    onChange={props.handleChange}
                  />
                  <div></div>
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Avancement</label>
                  <input
                    type="checkbox"
                    name="phAvancement"
                    defaultChecked={props.filterForm.current.phAvancement}
                    onChange={props.handleCheckboxChange} />
                </Col>
              </Form.Group>

            )}
          </Col>
          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="pdf"
              label="PDFs"
              defaultChecked={props.selectedOptions.current.includes('file')}
              onChange={() => handleOptionChange('file')}
            />
            {props.selectedOptions.current.includes('file') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <input
                    style={{height: '32px'}}
                    type="text"
                    className="chantierheure-input"
                    placeholder="Note"
                    name="pdNote"
                    defaultValue={props.filterForm.current.pdNote}
                    onChange={props.handleChange} />
                  <div></div>
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Permission</label>
                  <input
                    type="checkbox"
                    name="pdPermission"
                    defaultChecked={props.filterForm.current.pdPermission}
                    onChange={props.handleCheckboxChange} />
                </Col>
              </Form.Group>

            )}
          </Col>
          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="facture"
              label="Factures"
              defaultChecked={props.selectedOptions.current.includes('facture')}
              onChange={() => handleOptionChange('facture')}
            />
            
            {props.selectedOptions.current.includes('facture') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <Select
                    name="chantiers"
                    isMulti
                    options={props.facture}
                    className="form-control addcheckin-form-control-padding"
                    placeholder="Nom de facture"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: '20px',
                        width: '100%',
                      }),
                    }}
                    defaultValue={props.filterForm.current.faNomFacture}
                    onChange={props.handleListChange}
                  />
                  <div style={{height: '8px'}}></div>
                  <input
                    style={{height: '32px'}}
                    type="text"
                    className="chantierheure-input"
                    placeholder="Note"
                    name="faNote"
                    defaultValue={props.filterForm.current.faNote}
                    onChange={props.handleChange} />
                  <div></div>
                  <label style={{fontWeight: 'normal', marginRight: '7px'}}>Avancement</label>
                  <input
                    type="checkbox"
                    name="faAvancement"
                    defaultChecked={props.filterForm.current.faAvancement}
                    onChange={props.handleCheckboxChange}/>
                </Col>
              </Form.Group>

            )}
          </Col>

          <Col xs={6} md={4} lg={3} className="mb-2" style={{whiteSpace: 'nowrap'}}>
            <Form.Check
              type="checkbox"
              id="notes"
              label="Notes"
              defaultChecked={props.selectedOptions.current.includes('note')}
              onChange={() => handleOptionChange('note')}
            />
            {props.selectedOptions.current.includes('note') && (
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" style={{marginRight: '10px'}}>
                <Col sm="10">
                  <input
                    style={{height: '32px'}}
                    type="text"
                    className="chantierheure-input"
                    placeholder="Note"
                    name="noNote"
                    defaultValue={props.filterForm.current.noNote}
                    onChange={props.handleChange} />

                </Col>
              </Form.Group>
            )}
          </Col>
        </Row>
      </Form>
      <Button onClick={() => props.filterData()} style={{float: 'right', marginTop: '-10px', marginBottom: '10px', backgroundColor: 'black', color: 'white'}}>Filtrer <FontAwesomeIcon style={{marginLeft: '8px', marginBottom: '3px'}}
        icon={faFilter} /></Button>
    </Container>

  );
}

export default HistoriqueFilter;
